import { Component, OnInit, Input, ɵConsole, ViewChild, OnChanges, TemplateRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, Validators, FormGroup } from '@angular/forms';
import * as Konva from '../../../../assets/konva.js';
import * as Hammer from '../../../../assets/hammer.konva.js';
//import * as TouchEmulator from '../../../assets/touch-emulator.js';
import { EventService } from 'src/app/services/event.service'
import CanvasStage from 'src/app/models/native-map/canvas-stage.model';
import CanvasLayerImage from 'src/app/models/native-map/canvas-layer-image.model';
import CanvasLayerPlace from 'src/app/models/native-map/canvas-layer-place.model';
import { AlertService } from '../../../services/alert.service';
import CanvasPlace from 'src/app/models/native-map/canvas-place.model';
import { FORMERR } from 'dns';
import { NumberSymbol } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { GeneralHelper } from 'src/app/helpers/general.helper';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-map-place',
  templateUrl: './map-place.component.html',
  styleUrls: ['./map-place.component.css']
})

export class MapPlaceComponent implements OnInit {

  //@Input() baseClass: TicketBySectorComponent;

  @ViewChild('selectTicketPlace') selectTicketModal!: TemplateRef<any>;


  public blockedEvents = ['0b1f8c9a-f63d-4e33-a7ea-f9cd627de224', 'b20e3f73-8dc5-45e8-8a15-e66b0ba33c33', 'ea264f86-4a1e-4b35-98b4-1206c159a555', '05079705-0733-4b09-b51a-b40e2ca646db']
  public blockedTickets = ['b8564e3d-6de4-4094-a623-fb7ede754f4b', 'e58e2750-ffd5-40c1-a447-d553236ea728', '7164ca14-b156-437a-a671-289c5d300672', '0d9fa757-d621-4aa4-bf33-d4efbff6e02d',
    'a892d2c5-aa0b-43c2-85a7-b449e68aabe7', '560972da-0726-4aed-8f3e-93270c7c8ef3', 'c8e204f0-fb19-4d63-8c8a-7b7331df14bd', '7d8652a4-535d-4371-a3e8-7d993e76a35e']

  public selectedTicketName: string = ""

  // evento contendo o setor e ingressos
  @Input() event?: any;

  @Input() ticketCupom: string = '';

  @Input() ticketDescription: string | undefined = '';

  // id do setor selecionado
  @Input() sectorId?: string;

  // envia o assento, tickets selecionados ao componente pai
  @Output() sendSelectedSeat: EventEmitter<any> = new EventEmitter();

  /**
   * Aqui vai comportar o formulario do modal
   */
  public ticketSelectForm: FormArray = this.fb.array([]);

  public loadingModal: boolean = false

  /**
   * Lista de tickets permitidos para seleção do lugar selecionado
   */
  public permittedTicketsFromPlace: Array<{
    ticketId: string,
    ticketName: string,
    ticketDateId: string,
    lotId: string,
    fees: [],
    disabled?: boolean,
    finished?: string,
    type: string,
    position: number,
    ticketTags: string,
    sectorId: string,
    isMapPlace: boolean,
    placeId: string,
    placeName: string,
    orderMapReserveCode: string,
    unitPriceWithFee: number,
    unitPrice: number,
    fee: any
  }> = [];

  /**
   *  Configurações do lugar selecionado
   */
  public selectedPlace;


  public stage: any;

  public scale: number = 1;

  public zIndexLayerCount: number = 0;

  public ticketSelectFormShowError: boolean = false;

  public modalRef?: BsModalRef;

  /**
   * Se estiver true, está editando os ingressos do lugar
   */
  public onEditPlace: boolean = false;

  public loadingMap: boolean = false;

  /**
   * Esta movendo o mouse ou o dedo na tela
   */
  public blockClickPlace: boolean = false;

  public loadingConfirmPlace: boolean = false;

  public margin: number = 30;
  public marginW: number = 0;
  public marginH: number = 0;

  public iniX: number = 0;
  public iniY: number = 0;

  public amountSelectedTickets: number = 0

  /**
   * Mostra / oculta a seleção de tickets no modal de lugares
   */
  public modalShowSelectTickets: boolean = false;

  public isEspecialEvent: boolean = false;

  // Add a flag to track initial load
  private initialLoadComplete = false;

  constructor(
    private cdr: ChangeDetectorRef,
    public platform: Platform,
    private fb: FormBuilder,
    private alertService: AlertService,
    private eventService: EventService,
    private generalHelper: GeneralHelper,
    private modalService: BsModalService,
    private orderService: OrderService) { }

  ngOnInit() {
    if (this.sectorId && !this.initialLoadComplete) {
      this.loadMapPlace();
      this.initialLoadComplete = true;
    }

    var canvas_dom = (document.getElementById('canvas') as any);
    canvas_dom.addEventListener("touchmove", function (event) {
      event.preventDefault();
    });

    canvas_dom.addEventListener("touchstart", function (event) {
      event.preventDefault();
    });

    canvas_dom.addEventListener("touchend", function (event) {
      event.preventDefault();
    });

    canvas_dom.addEventListener("touchcancel", function (event) {
      event.preventDefault();
    });

    window.addEventListener("resize", () => {
      let width = this.getWidthMap();
      if (this.stage && width) {
        this.stage.setWidth(width);
        this.stage.batchDraw();
      }
    });
  }

  ngOnChanges(changes: any) {
    // Only reload if:
    // 1. Initial load hasn't happened and we have sectorId, or
    // 2. sectorId has changed after initial load
    if (changes.sectorId && changes.sectorId.currentValue) {
      if (!this.initialLoadComplete || !changes.sectorId.firstChange) {
        this.sectorId = changes.sectorId.currentValue;
        this.loadMapPlace();
        this.initialLoadComplete = true;
      }
    }
  }

  getWidthMap() {
    let div = document.getElementById('box-map-place');
    return (div && div.clientWidth) ? div.clientWidth : null
  }

  getHeightMap() {
    let div = document.getElementById('box-map-place');
    return (div && div.clientHeight) ? div.clientHeight : 0
  }

  getHeightZoomBar() {
    return this.getHeightMap() - 80;
  }



  /**
   * Aqui vamos carregar o mapa na tela
   */

  loadMapPlace() {

    Konva.pixelRatio = 1;
    Konva.hitOnDragEnabled = true;
    Konva.captureTouchEventsEnabled = true;
    this.loadingMap = true;

    if (this.stage) {
      this.stage.destroy();
    }

    this.eventService.getMap({ sectorId: this.sectorId, orderMapReserveCode: this.uniqueIdGenerate() })
      .subscribe((res: any) => {

        let getNumber = (number: number | undefined) => {
          return (number) ? number : 0
        }

        //Se já tem um mapa cadastrado para o setor, vamos carregá-lo na tela.
        let data = res[0];
        let iniX: number, endX: number, iniY: number, endY: number, defineScale: number = 1;
        let isMobile = false;

        if (window.screen.width <= 1000) {
          isMobile = true;
        }


        //Palco
        let stageRegistered: CanvasStage = JSON.parse(data.canvas);

        let attrs = stageRegistered.attrs;
        attrs.container = 'canvas';
        attrs.idDB = data.id;
        attrs.width = 100;
        attrs.height = !isMobile ? 500 : 350;
        this.stage = new Konva.Stage(attrs);
        this.scale = this.stage.scaleX();

        // attach modified version of Hammer.js
        // "domEvents" property will allow triggering events on group
        // instead of "hammertime" instance
        var hammertime = new Hammer(this.stage, { domEvents: true });

        // add rotate gesture
        hammertime.get('rotate').set({ enable: true });

        let text, cloneCircle, cloneRect;
        //Layers
        for (let l = 0; l < data.layers.length; l++) {
          let layerRegistered = data.layers[l];
          let layerRegisteredCanvas: CanvasLayerImage | CanvasLayerPlace = JSON.parse(layerRegistered.canvas);
          layerRegisteredCanvas.attrs.draggable = false;
          layerRegisteredCanvas.attrs.idDB = layerRegistered.id;

          let attrs = layerRegisteredCanvas.attrs;
          delete attrs.configs;

          let layer;
          //A layer é do tipo background, então faremos as tratativas para carregar uma layer desse tipo
          if (attrs.type == 'background') {
            layer = new Konva.FastLayer(attrs);
            layer.transformsEnabled('position');
            for (let bi = 0; bi < layerRegisteredCanvas.children.length; bi++) {

              if (layerRegisteredCanvas.children[bi].attrs.type == 'background-image') {

                let attrs: any = layerRegisteredCanvas.children[bi].attrs;

                let image = new Image();
                let imageType = this.generalHelper.getFileTypeFromBase64(attrs.imageBase64);
                image.src = "data:" + imageType + ";base64," + attrs.imageBase64;


                //
                delete attrs.imageBase64;
                //
                image.onload = () => {
                  attrs.image = image;
                  attrs.width = image.width;
                  attrs.height = image.height;
                  var bg = new Konva.Image(attrs);

                  bg.transformsEnabled('position');
                  layer.add(bg);
                  layer.draw();

                  let posItemXIni = getNumber(layer.attrs.x);
                  let posItemXEnd = getNumber(layer.attrs.x) + getNumber(image.width);

                  let posItemYIni = getNumber(layer.attrs.y);
                  let posItemYEnd = getNumber(layer.attrs.y) + getNumber(image.height);

                  //Vamos pegar o menor número de x existente e o maior numero de x existente
                  iniX = (!iniX || iniX > posItemXIni) ? posItemXIni : iniX;
                  endX = (!endX || endX < posItemXEnd) ? posItemXEnd : endX;

                  iniY = (!iniY || iniY > posItemYIni) ? posItemYIni : iniY;
                  endY = (!endY || endY < posItemYEnd) ? posItemYEnd : endY;

                }
              }
            }
          } else {    //Se a layer nao é do tipo background, é do tipo que comporta lugares.
            // Só existe esses 2 tipos hoje.
            layer = new Konva.Layer(attrs);
            layer.transformsEnabled('position');
            var attrsLayer = attrs;

            //Grupo
            for (let p = 0; p < layerRegistered.places.length; p++) {
              let placeRegistered = layerRegistered.places[p];
              let placeRegisteredCanvas: CanvasPlace = JSON.parse(layerRegistered.places[p].canvas);
              let attrs = placeRegisteredCanvas.attrs;
              attrs.idDB = placeRegistered.id;
              //delete attrs.configs;
              attrs.configs.qtdPerson = placeRegistered.qtdPerson;
              attrs.configs.qtdDisponible = placeRegistered.qtdDisponible;
              //Grupo que vai encapsular o quadrado ou circulo do lugar + texto com nome do lugar
              let group = new Konva.Group(attrs);
              //Indica que o grupo não será redimensionado (melhoria desempenho)
              group.transformsEnabled('position');

              //Se tem lugar disponível, o grupo é clicavel, se não tem lugar disponível não é clicável e para de "ouvir" ações de clicks (melhoria desempenho)
              if (attrs.configs.qtdDisponible > 0) {
                this.onClickPlace(group, attrs.id);
              } else {
                group.listening(false);
              }

              //Itens do grupo
              for (let i = 0; i < placeRegisteredCanvas.children.length; i++) {
                let item = placeRegisteredCanvas.children[i];
                let posItemXIni, posItemXEnd, posItemYIni, posItemYEnd, width, height;


                //Agora vamos preparar o texto e o quadrado ou circulo


                if (item.className == 'Circle' || item.className == 'Rect') {
                  let attrs = item.attrs;
                  //  delete attrs.stroke;
                  //attrs.listening = false;

                  //Se não está disponível, vamos acinzentá-lo
                  if (group.attrs.configs.qtdDisponible == 0) {
                    attrs.fill = 'rgba(204,204,204,1)';
                  }

                  // Se está no carrinho, marca com a cor de selecionado
                  if (this.orderService.getAllTickets().filter(v => v.placeId == group.attrs.idDB).length > 0) {
                    attrs.fill = 'rgba(247, 220, 43, 1)';
                  }


                  if (item.className == 'Circle') {

                    //Posição absoluta do item
                    posItemXIni = getNumber(layer.attrs.x) + getNumber(group.attrs.x) + getNumber(item.attrs.x) - (getNumber(item.attrs.radius));
                    posItemXEnd = getNumber(layer.attrs.x) + getNumber(group.attrs.x) + getNumber(item.attrs.x) + (getNumber(item.attrs.radius));

                    posItemYIni = getNumber(layer.attrs.y) + getNumber(group.attrs.y) + getNumber(item.attrs.y) - (getNumber(item.attrs.radius));
                    posItemYEnd = getNumber(layer.attrs.y) + getNumber(group.attrs.y) + getNumber(item.attrs.y) + (getNumber(item.attrs.radius));

                    if (cloneCircle && cloneCircle.attrs.fill == attrs.fill) {

                      let clone = cloneCircle.clone({ x: attrs.x, y: attrs.y });
                      clone.cache();
                      group.add(clone);

                    } else {
                      let placebox = new Konva.Circle(attrs);
                      placebox.transformsEnabled('position');
                      placebox.hitStrokeWidth(0);
                      placebox.perfectDrawEnabled(false);
                      group.add(placebox);
                      placebox.cache();

                      cloneCircle = placebox.clone();

                    }

                  }

                  if (item.className == 'Rect') {
                    //Posição absoluta do item
                    posItemXIni = getNumber(layer.attrs.x) + getNumber(group.attrs.x) + getNumber(item.attrs.x);
                    posItemXEnd = getNumber(layer.attrs.x) + getNumber(group.attrs.x) + getNumber(item.attrs.x) + (getNumber(item.attrs.width));

                    posItemYIni = getNumber(layer.attrs.y) + getNumber(group.attrs.y) + getNumber(item.attrs.y);
                    posItemYEnd = getNumber(layer.attrs.y) + getNumber(group.attrs.y) + getNumber(item.attrs.y) + (getNumber(item.attrs.height));


                    if (cloneRect && cloneRect.attrs.fill == attrs.fill) {
                      let clone = cloneRect.clone(attrs);
                      clone.cache();
                      group.add(clone);
                    } else {
                      let placebox = new Konva.Rect(attrs);
                      placebox.transformsEnabled('position');
                      placebox.hitStrokeWidth(0);
                      placebox.perfectDrawEnabled(false);
                      group.add(placebox);
                      placebox.cache();
                      cloneRect = placebox.clone();
                    }
                  }

                  let iniX: number = 0;
                  let endX: number = 0;

                  let iniY: number = 0;
                  let endY: number = 0;
                  //Vamos pegar o menor número de x existente e o maior numero de x existente
                  iniX = (!iniX || iniX > posItemXIni) ? posItemXIni : iniX;
                  endX = (!endX || endX < posItemXEnd) ? posItemXEnd : endX;

                  iniY = (!iniY || iniY > posItemYIni) ? posItemYIni : iniY;
                  endY = (!endY || endY < posItemYEnd) ? posItemYEnd : endY;

                }

                if (item.className == 'Text') {
                  let attrs = item.attrs;

                  // if(this.baseClass.selectedSectorId == 'b55ba11f-2d5a-4298-a878-ce5962ada11f'){
                  //   item.attrs.width = 20;
                  //   item.attrs.offsetX = 10;
                  //   item.attrs.offsetY = 5;
                  // }

                  //attrs.listening = false;
                  text = new Konva.Text(attrs);
                  text.transformsEnabled('position');
                  text.hitStrokeWidth(0);
                  text.perfectDrawEnabled(false);
                  group.add(text);
                }
                //}

              }
              layer.add(group);
            }
          }

          this.stage.add(layer);
          this.stage.container().style.cursor = 'pointer';

          layer.zIndex(this.zIndexLayerCount);
          this.zIndexLayerCount += 1;

        }



        this.loadingMap = false;

        this.initZoom();
        this.initPosition();

        this.loadingMap = false;
        setTimeout(() => {
          let divWidth = this.getWidthMap();
          let divHeight = this.getHeightMap() - 149;
          this.stage.setWidth(divWidth);
          // this.stage.batchDraw();
          if (this.event.id == "0b1f8c9a-f63d-4e33-a7ea-f9cd627de224") {
            this.scale = 0.3
            this.stage.scale({ x: this.scale, y: this.scale });

            this.stage.position({ x: -250, y: - (this.iniY * this.scale) + (this.marginH / 2) });

            this.stage.batchDraw();

          } else if (this.event.id == "0680522e-20a3-446f-827c-567d99552196" || this.event.id == "e6a8866d-d0d5-4a5a-b478-b537aeed3941") {
            if (window.innerWidth > 800) {
              this.scale = 0.2
              this.stage.scale({ x: this.scale, y: this.scale });
              this.stage.position({ x: -(this.iniX * this.scale) + (divWidth! / 5), y: - (this.iniY * this.scale) + (divHeight! / 5), });
              // this.stage.position({x: -((this.iniX * this.scale) + (divWidth! ) )/2, y:- (this.iniY * this.scale) + (divHeight! / 5), });
              this.stage.batchDraw();
            } else {
              this.scale = 0.1
              this.stage.scale({ x: this.scale, y: this.scale });
              this.stage.position({ x: -(this.iniX * this.scale) + (divWidth! / 12), y: - (this.iniY * this.scale) + (divHeight! / 5), });
              // this.stage.position({x: -((this.iniX * this.scale) + (divWidth! ) )/2, y:- (this.iniY * this.scale) + (divHeight! / 5), });
              this.stage.batchDraw();
            }

          } else {
            this.scale = 0.7
            this.stage.scale({ x: this.scale, y: this.scale });
            this.stage.position({ x: divWidth! / 5, y: divHeight! / 5, });
            this.stage.batchDraw();
          }

          // let divWidth = this.getWidthMap();
          // let divHeight = this.getHeightMap();
          // this.stage.setWidth(divWidth);
          //
          // this.marginW = 30;
          // this.marginH = 30;
          //
          // this.iniX = iniX;
          // this.iniY = iniY;
          //
          // let widthMapInner = endX - iniX;
          // let heightMapInner = endY - iniY;
          //
          // if( (divWidth! * this.scale /  widthMapInner) <  (this.stage.height() * this.scale /  heightMapInner)){
          //   this.marginW = this.margin;
          // }else{
          //   this.marginW = (divWidth! - widthMapInner) - this.margin;
          // }
          //
          //
          // //this.marginH = (divHeight - heightMapInner) / 2;
          // this.marginH = 30;
          //
          // let newScaleBasedWidth =  (divWidth! - this.marginW) * this.scale /  widthMapInner;
          // let newScaleBasedHeight =  (this.stage.height() - this.marginH) * this.scale /  heightMapInner;
          //
          // let newScale = (newScaleBasedWidth < newScaleBasedHeight) ? newScaleBasedWidth : newScaleBasedHeight;
          // //let newScale = newScaleBasedWidth;
          //
          // this.stage.scale({ x: newScale, y: newScale });
          // let newHeight = (heightMapInner * newScale) + this.marginH;
          // this.stage.height((newHeight < 300) ? 300 : newHeight);
          // this.scale = newScale;
          //
          // this.stage.position({x: -(iniX * newScale) + (this.marginW / 2), y:- (iniY * newScale) + (this.marginH / 2) });
          //
          //
          // this.stage.batchDraw();
        }, 100);


      });

  }

  getRelativePosition(x: number, y: number) {
    if (!this.stage) {
      return null;
    }
    return {
      x: x / this.scale - (this.stage.x() / this.scale),
      y: y / this.scale - (this.stage.y() / this.scale),
    };
  }

  /**
   * Ação para dar zoom rolando o scroll do mouse
   */
  initZoom() {
    var scaleBy = 1.21;

    let zoomMouseWheel = (eve) => {
      eve.evt.preventDefault();
      var oldScale = this.stage.scaleX();

      var mousePointTo = {
        x: this.getPointerPosition().x,
        y: this.getPointerPosition().y
      };

      var newScale = eve.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;
      this.stage.scale({ x: newScale, y: newScale });
      this.scale = newScale;

      var newPos = {
        x:
          -(mousePointTo.x - this.stage.getPointerPosition().x / newScale) *
          newScale,
        y:
          -(mousePointTo.y - this.stage.getPointerPosition().y / newScale) *
          newScale
      };
      this.stage.position(newPos);
      this.stage.batchDraw();
    }

    let zoomPinchMobile = (eve) => {
      eve.evt.preventDefault();
      var oldScale = this.stage.scaleX();

      var mousePointTo = {
        x: this.getPointerPosition().x,
        y: this.getPointerPosition().y
      };

      var newScale = eve.evt.gesture.scale;
      this.stage.scale({ x: newScale, y: newScale });
      this.scale = newScale;

      var newPos = {
        x:
          -(mousePointTo.x - this.stage.getPointerPosition().x / newScale) *
          newScale,
        y:
          -(mousePointTo.y - this.stage.getPointerPosition().y / newScale) *
          newScale
      };
      this.stage.position(newPos);
      this.stage.batchDraw();
    }

    this.stage.on('wheel', eve => {
      zoomMouseWheel(eve);
      // eve.preventDefault();
    });

    this.stage.on('rotatestart', eve => {
      this.blockClickPlace = true;
    });

    this.stage.on('rotate', eve => {
      zoomPinchMobile(eve);
      eve.preventDefault();
    });

    this.stage.on('rotateend', eve => {
      this.blockClickPlace = false;
    });
  }

  /**
   * Para capturar a posição do mouse/toque na tela use essa função.
   */
  getPointerPosition() {
    return {
      x: this.stage.getPointerPosition().x / this.scale - (this.stage.x() / this.scale),
      y: this.stage.getPointerPosition().y / this.scale - (this.stage.y() / this.scale),
    };
  }

  /**
   * Ação para movimentar mapa na tela
   */
  initPosition() {

    let positionMoveStart = false;

    let startPosition: any = {};

    let initDrag = () => {
      positionMoveStart = true;

      startPosition = {
        x: this.getPointerPosition().x,
        y: this.getPointerPosition().y
      };
    }


    let endDrag = () => {
      positionMoveStart = false;
    };

    let move = () => {
      if (positionMoveStart) {
        let calc = {
          x:
            -(startPosition.x - this.stage.getPointerPosition().x / this.scale) *
            this.scale,
          y:
            -(startPosition.y - this.stage.getPointerPosition().y / this.scale) *
            this.scale
        };


        this.stage.position(calc);
        this.stage.batchDraw();
      }
    };


    this.stage.on('mousedown', eve => {
      this.blockClickPlace = false;
      initDrag();
      /*if(eve){
        eve.preventDefault();
      }*/
    });

    this.stage.on('touchstart', eve => {
      this.blockClickPlace = false;
      initDrag();
      eve.preventDefault();
    });

    this.stage.on('mouseup', eve => {
      endDrag();
      //e.preventDefault();
    });

    this.stage.on('touchend', eve => {
      endDrag();
      eve.preventDefault();
    });

    this.stage.on('mousemove', eve => {
      this.blockClickPlace = true;
      move();
    });

    this.stage.on('touchmove', eve => {
      this.blockClickPlace = false;
      move();
      eve.preventDefault();
    });

    this.stage.on('touchcancel', eve => {
      eve.preventDefault();
    });

  }

  onClickPlace(place, idPlace) {
    let actionPlace = () => {

      if (!this.blockClickPlace) {
        this.selectedPlace = place;
        this.loadModal();
        if (this.modalShowSelectTickets == false) {
          let ticket = this.event.tickets.filter((ticket) => {
            if (ticket.ticketDateId == this.selectedPlace.attrs.configs.tickets[0]) {
              return ticket
            }
          })

          this.selectedTicketName = ticket[0]["name"]
        }

        this.onEditPlace = (this.orderService.getAllTickets().filter(v => v.placeId == this.selectedPlace.attrs.idDB).length > 0);


      }
    }

    place.on('click', eve => {
      actionPlace();
    });

    place.on('touchend', eve => {
      actionPlace();
    });
  }

  loadModal() {
    this.loadingModal = true
    this.modalRef = this.modalService.show(this.selectTicketModal);
    this.ticketSelectFormShowError = false;
    this.modalShowSelectTickets = true;

    this.loadingModal = false
    //  let event = this.baseClass.baseClass.event;
    this.ticketSelectForm = this.fb.array([]);
    /**
    * Com base no lugar selecionado, vamos captar somente os ingressos permitidos nesse lugar para exibir no selectbox
    */
    this.permittedTicketsFromPlace = [];
    this.event.tickets.forEach((ticket, iT) => {
      if (ticket.sectorId == this.sectorId) {
        if (this.selectedPlace.attrs.configs.tickets.indexOf(ticket.ticketDateId) != -1) {
          this.permittedTicketsFromPlace.push(
            {
              ticketId: ticket.id,
              ticketName: ticket.name,
              fees: ticket.fees,
              ticketDateId: ticket.ticketDateId,
              lotId: ticket.lotId,
              type: ticket.type,
              disabled: this.blockedTickets.indexOf(ticket.id) > -1 && this.blockedEvents.indexOf(this?.event.id) > -1 ? true : false,
              finished: this.blockedTickets.indexOf(ticket.id) > -1 && this.blockedEvents.indexOf(this?.event.id) > -1 ? 'Esgotado' : '',
              placeName: this.selectedPlace.attrs.name,
              ticketTags: this.ticketCupom,
              isMapPlace: true,
              placeId: this.selectedPlace.attrs.idDB,
              orderMapReserveCode: '',
              position: ticket.position,
              sectorId: ticket.sectorId,
              unitPriceWithFee: ticket.price + ticket.fee,
              unitPrice: ticket.price,
              fee: ticket.fee
            }
          );
        }
      }
    });


    // Se só tem 1 ingresso pra selecionar no selectbox, ele já pode sair selecionado automaticamente
    let firstTicketSelected = (this.permittedTicketsFromPlace.length == 1) ? this.permittedTicketsFromPlace[0].ticketDateId : null;
    /**
     * Se o lugar é do tipo 'single', o usuário é obrigado a selecionar a quantidade de ingressos que o lugar comporta.
     */
    if (this.selectedPlace.attrs.configs.type == 'single') {
      for (let i = 0; i < this.selectedPlace.attrs.configs.quantity; i++) {
        this.ticketSelectForm.push(this.fb.group({
          'dateTicketId': [firstTicketSelected, Validators.required]
        }));
      }
      //Se estiver editando, marca os ingressos selecionados
      if (this.onEditPlace) {
        let selectedTickets = this.orderService.getAllTickets().filter(v => v.placeId == this.selectedPlace.attrs.idDB);
        selectedTickets.forEach((value, index, array) => {
          this.ticketSelectForm.at(index).get('dateTicketId')?.setValue(value.ticketDateId);
        });
      }

      //Se o lugar é do tipo single, e só tem 1 ingresso pra selecionar, nem precisa mostrar os selectbox de seleção, já sairá selecionado o unico ingresso que tem.
      if (this.permittedTicketsFromPlace.length == 1) {
        this.modalShowSelectTickets = false;
      }
    }
    /**
    * Se o lugar é do tipo 'shared', o usuário pode selecionar 1 ou n ingressos de acordo com o limite disponível
    */
    else if (this.selectedPlace.attrs.configs.type == 'shared') {



      if (this.onEditPlace) {
        let selectedTickets = this.orderService.getAllTickets().filter(v => v.placeId == this.selectedPlace.attrs.idDB);
        selectedTickets.forEach((value, index, array) => {
          this.ticketSelectForm.push(this.fb.group({
            'dateTicketId': [value.ticketDateId, Validators.required]
          }));
        });
      } else {
        this.ticketSelectForm.push(this.fb.group({
          'dateTicketId': [firstTicketSelected, Validators.required]
        }));
      }

    } else {
      this.alertService.toast({ icon: 'error', title: 'Erro', text: 'Tipo do lugar não identificado' });
    }

  }

  getTicketChange(eve: any) {
    this.selectedTicketName = eve.ticketName
  }

  /**
   * O formulário do modal foi submetido
   */
  submitSelectedTickets() {
    if (!this.ticketSelectForm.valid) {
      this.ticketSelectFormShowError = true;
    } else if (this.ticketSelectForm.value.length == 0) {
      this.alertService.toast({ icon: 'error', title: 'Erro', text: 'Adicione pelo menos 1 pessoa' });
    } else if (this.isEspecialEvent &&
      this.ticketSelectForm.value.length < 4) {
      this.alertService.toast({ icon: 'error', title: 'Erro', text: 'Adicione pelo menos 4 pessoas' });
    } else {
      let data = {
        code: this.uniqueIdGenerate(),
        places: [
          {
            placeId: this.selectedPlace.attrs.idDB,
            qtdPerson: this.ticketSelectForm.value.length
          }
        ]
      };


      this.loadingConfirmPlace = true;
      this.orderService.newMapReserve(data).subscribe(res => {
        this.loadingConfirmPlace = false;
        let placebox = this.selectedPlace.children.filter(v => (v.attrs.type == 'placebox'))[0];
        placebox.fill('rgba(247, 220, 43, 1)');
        placebox.clearCache();

        this.stage.batchDraw();
        this.modalRef?.hide();
        this.amountSelectedTickets = this.amountSelectedTickets + 1
        // adiciona a seleção feita no modal no carrinho
        // this.orderService.emptyAllTickets()
        for (let i = 0; i < this.ticketSelectForm.value.length; i++) {
          let selected = this.ticketSelectForm.value[i];

          const placeAlreadyInCart = this.orderService
            .getAllTickets()
            .filter(
              (ticket) =>
                ticket.placeId == this.selectedPlace.attrs.idDB
            );

          if (placeAlreadyInCart?.length >= this.selectedPlace.attrs.configs.qtdDisponible) {
            continue;
          }

          let ticket = this.permittedTicketsFromPlace.filter(v => v.ticketDateId == selected.dateTicketId)[0];
          let ticketOrder = {
            fee: ticket.fee,
            fees: ticket.fees,
            id: ticket.ticketId,
            orderMapReserveCode: data.code != null ? data.code : undefined,
            ticketDateId: ticket.ticketDateId,
            name: ticket.ticketName,
            price: ticket.unitPrice,
            qty: 1,
            isMapPlace: ticket.isMapPlace,
            placeName: ticket.placeName,
            position: ticket.position,
            lotId: ticket.lotId,
            sectorId: ticket.sectorId,
            placeId: this.selectedPlace.attrs.idDB,
            unitPrice: ticket.unitPrice.toString(),
            unitPriceWithFee: ticket.unitPriceWithFee.toString(),
          }
          this.sendSelectedSeat.emit([this.amountSelectedTickets, this.sectorId]);
          this.orderService.addTicket(ticketOrder);
        }

        //   let ticket = this.permittedTicketsFromPlace.filter(v => v.ticketDateId == selected.dateTicketId)[0];
        //   this.baseClass.cartTikets.push(
        //     {
        //       ticketId: ticket.ticketId,
        //       ticketName: ticket.ticketName,
        //       ticketDateId: ticket.ticketDateId,
        //       lotId: ticket.lotId,
        //       lotName: ticket.lotName,
        //       quantity: 1,
        //       unitPrice: ticket.unitPrice,
        //       unitPriceWithoutFee: ticket.unitPriceWithoutFee,
        //       customer: null,
        //       placeId: this.selectedPlace.attrs.idDB,
        //       placeName: this.selectedPlace.attrs.name,
        //       fee: ticket.fee
        //     }
        //   );
        // }
      });


      // this.orderService.newReserve(data).then(responseve => {
      //   this.loadingConfirmPlace = false;
      //   let placebox = this.selectedPlace.children.filter(v => (v.attrs.type == 'placebox'))[0];
      //
      //   placebox.fill('rgba(247, 220, 43, 1)');
      //   placebox.clearCache();
      //
      //   this.stage.batchDraw();
      // //  this.modalService.dismissAll();
      //
      //   /**
      //    * Se O lugar selecionado já está adicionado no carrinho, vamos remover para adicionar a nova seleção feita no modal para o lugar
      //    */
      //
      //   //  this.baseClass.cartTikets = this.baseClass.cartTikets.filter(v => v.placeId != this.selectedPlace.attrs.idDB);
      //
      //   /**
      //    * Adiciona a seleção feita no modal no carrinho
      //    */
      //   for(let i=0; i < this.ticketSelectForm.value.length; i++){
      //     let selected = this.ticketSelectForm.value[i];
      //
      //     // let ticket = this.permittedTicketsFromPlace.filter(v => v.ticketDateId == selected.dateTicketId)[0];
      //     //   this.baseClass.cartTikets.push(
      //     //     {
      //     //       ticketId: ticket.ticketId,
      //     //       ticketName: ticket.ticketName,
      //     //       ticketDateId: ticket.ticketDateId,
      //     //       lotId: ticket.lotId,
      //     //       lotName: ticket.lotName,
      //     //       quantity: 1,
      //     //       unitPrice: ticket.unitPrice,
      //     //       unitPriceWithoutFee: ticket.unitPriceWithoutFee,
      //     //       customer: null,
      //     //       placeId: this.selectedPlace.attrs.idDB,
      //     //       placeName: this.selectedPlace.attrs.name,
      //     //       fee: ticket.fee
      //     //     }
      //     //   );
      //   }
      // }).catch(errorResponseve => {
      //   this.loadingConfirmPlace = false;
      //  //this.validatorsInputErrorComponent.loadErrors(errorResponse, null);
      // });

    }

  }

  newTicket() {
    let disponible = this.selectedPlace.attrs.configs.qtdDisponible;
    if (disponible > this.ticketSelectForm.value.length) {
      this.ticketSelectForm.push(this.fb.group({
        'dateTicketId': [null, Validators.required]
      }));
    } else {
      this.alertService.toast({ icon: 'error', title: 'Limite de ingressos atingido', text: 'Você só pode selecionar ' + disponible + ' ingressos para este lugar.' });
    }
  }

  removeTicket(position: number) {
    this.ticketSelectForm.removeAt(position);
  }

  cancelPlace() {
    if (this.amountSelectedTickets >= 1) {
      this.amountSelectedTickets = this.amountSelectedTickets - 1
    }
    this.sendSelectedSeat.emit([this.amountSelectedTickets, this.sectorId]);

    //Remove do carrinho
    this.orderService.removeTicketByPlaceId(this.selectedPlace.attrs.idDB);

    let placebox = this.selectedPlace.children.filter(v => (v.attrs.type == 'placebox'))[0];

    placebox.fill(placebox.attrs.fillDefined);
    placebox.clearCache();

    this.stage.batchDraw();

    this.modalRef?.hide();

  }


  /**
   * Rolou a barra de rolagem do zoom
   */
  changeZoomSlider() {
    this.stage.scale({ x: this.scale, y: this.scale });

    this.stage.position({ x: -450, y: - (this.iniY * this.scale) + (this.marginH / 2) });

    this.stage.batchDraw();
  }

  zoomIn() {
    this.scale += 0.1;
    this.stage.scale({ x: this.scale, y: this.scale });

    this.stage.position({ x: -(this.iniX * this.scale) + (this.marginW / 2), y: - (this.iniY * this.scale) + (this.marginH / 2) });

    this.stage.batchDraw();
  }

  zoomOut() {
    this.scale -= 0.1;
    this.stage.scale({ x: this.scale, y: this.scale });

    this.stage.position({ x: -(this.iniX * this.scale) + (this.marginW / 2), y: - (this.iniY * this.scale) + (this.marginH / 2) });

    this.stage.batchDraw();
  }


  instructionsStatus() {
    return localStorage.getItem('instructions_understand');
  }

  okUnderstand() {
    localStorage.setItem('instructions_understand', '1');
  }

  uniqueIdGenerate() {

    if (!localStorage.getItem('map_session_reserve')) {
      localStorage.setItem('map_session_reserve', this.generalHelper.guid());
    }

    return localStorage.getItem('map_session_reserve');
  }

  priceTotalPlace() {
    let total = 0;
    for (let i = 0; i < this.ticketSelectForm.controls.length; i++) {
      let search = this.permittedTicketsFromPlace.find(v => v?.ticketDateId == this.ticketSelectForm.at(i).get('dateTicketId')?.value);
      if (search) {
        total += search.unitPrice + search.fee;
      }
    }

    return total;
  }



}
